var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3414 0.510742C23.0004 0.329357 27.9803 2.5042 31.2633 5.79883C37.5802 12.1383 38.2509 22.3729 32.7408 29.4893C29.4148 33.785 24.1133 36.4668 18.6734 36.4521H18.3414C9.13121 36.4372 1.35504 29.194 0.587494 20.0127C-0.271597 9.7344 7.946 0.453016 18.3189 0.510742H18.3414ZM17.7545 2.53809L17.7252 2.54004C13.6026 2.95411 10.1519 4.3177 7.20468 7.33496C2.02488 12.6384 1.2401 20.771 5.1373 27.0742C5.47279 27.6168 5.86092 28.2293 6.32187 28.7441L6.91757 29.4102L7.17343 28.5537C7.65307 26.948 8.13668 25.6712 8.8746 24.5869C9.60574 23.5128 10.6057 22.6013 12.1568 21.7637C12.7637 21.4359 13.8065 20.9311 14.4586 20.7363C16.0655 21.5212 17.2575 21.9965 19.3121 21.8428L19.3521 21.8398L19.3912 21.8301C20.017 21.6796 20.7781 21.555 21.4742 21.2617C21.7075 21.1634 21.927 21.0385 22.1139 20.9346C22.2476 20.8602 22.3687 20.7967 22.484 20.7422C25.4248 21.7772 27.5508 22.989 28.9742 25.9111C29.3818 26.748 29.5838 27.5894 29.8775 28.5557L30.1852 29.5703L30.7721 28.6875C30.8845 28.5182 31.0081 28.353 31.1412 28.1777C31.2717 28.006 31.4141 27.8212 31.5475 27.6299C39.0244 16.9015 31.001 2.00747 17.7545 2.53809Z",
    fill: "#FFF8DC",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2623 8.71191C22.9488 8.52881 25.3945 14.0047 22.2594 17.3066C21.3751 18.2379 20.0976 18.8091 18.7594 18.874C15.8423 18.9253 13.4739 16.9394 13.3004 14.2559C13.1158 11.3992 15.221 8.89964 18.2623 8.71191Z",
    fill: "#FFF8DC",
    stroke: "#E8E8E8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserp);
export default __webpack_public_path__ + "static/media/userp.9f062db076e44946f7e78c174d05a6bf.svg";
export { ForwardRef as ReactComponent };